import EmailValidator from 'email-validator'
import { IContactPatchBody } from '../../types/API'

export const billingEmailTest = (
  billing?: IContactPatchBody,
): string | false => {
  if (!billing?.email) return 'Billing contact requires email'

  if (
    typeof billing.email === 'string'
    && !EmailValidator.validate(billing.email)
  ) {
    return 'Billing contact email invalid'
  }

  if (typeof billing.email === 'object') {
    return billing.email.some((email) => !EmailValidator.validate(email))
      ? 'A billing contact email is invalid'
      : false
  }

  return false
}
